import { Identifiable } from "./identifiable";
import { project, Project } from "./project";
import { list, List } from "./list";
import { event, Event } from "./event";
import { id } from "./id";

type EventRetrievalResponse = Identifiable<Event> & {
  list: Identifiable<List>;
  project: Identifiable<Project>;
};

const eventRetrievalResponse: EventRetrievalResponse = {
  list: { ...list, uuid: id },
  project: { ...project, uuid: id },
  uuid: "",
  ...event,
};

export type { EventRetrievalResponse };

export { eventRetrievalResponse };
